import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import {
  getFormData,
  getFormUploads,
  getProcessInstances,
  updateFormField,
} from 'store/forms/actions';
import { TabsTimeline, FormFooter, TabsTimelineSub } from 'components';
import { isNil, isNull } from 'lodash';
import {
  checkUser,
  checkUserLogged,
  getUser,
  getTaxisData,
} from 'store/user/actions';
import { getMainformDetails } from 'store/forms/actions';
import { stepsBeneficiary } from './stepsBeneficiary';
import { useNavigate } from 'react-router-dom';
import { isBeneficiary, isKtP, isProvider } from '../../../utils';
import { ValidationBanner } from 'components/layout/components';

import isEmpty from 'lodash/isEmpty';
import { Spin } from 'antd';

const MainForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [current, setCurrent] = useState(0);
  const currentSubTab = useSelector(state => state.forms.carrier.currentSubTab);

  // const [requiredFieldsError, setRequiredFieldsError] = useState(true);
  const user = useSelector(state => state.user);
  const privileges = useSelector(state => state.user.privileges);
  const task = useSelector(state => state.forms.task);
  const viewMode = useSelector(state => state.forms.carrier.viewMode);
  const carrier = useSelector(state => state.forms.carrier);
  const activeFormId = useSelector(state => state?.activeForm?.activeFormId);
  const forms = useSelector(state => state.forms);
  const loadingPage = useSelector(state => state.user.loading);
  const [loadingPageVar, setLoadingPageVar] = useState(true);
  const activeTaskName = useSelector(state => state.forms?.activeTaskName);

  useEffect(() => {
    dispatch(getUser());
    dispatch(getTaxisData());
    dispatch(getFormData(params.taskId));
    dispatch(getFormUploads(params.taskId));
    if (window.location.pathname.includes('view')) {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'viewMode',
          value: true,
        })
      );
    }
  }, [dispatch, params.taskId]);

  // useEffect(()=>{
  //   console.log("current:",current);
  //   console.log("currentSubTab:",currentSubTab);
  //   dispatch(
  //     updateFormField({
  //       group: 'carrier',
  //       key: 'currentSubTab',
  //       value: 0,
  //     })
  //   );
  // },[current])

  useEffect(() => {
    if (viewMode || (!isEmpty(user?.groups) && !isBeneficiary(user?.groups))) {
      dispatch(getMainformDetails(activeFormId));
    }
  }, [user?.groups]);

  useEffect(() => {
    if (!isNil(loadingPage)) {
      setLoadingPageVar(loadingPage);
    }
  }, [loadingPage]);

  useEffect(() => {
    dispatch(
      checkUserLogged(navigate, callback => {
        if (callback) {
          dispatch(getUser());
        }
      })
    );
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(checkUser(navigate));
    }, process.env.REACT_APP_SESSION_CHECK_TIME);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    dispatch(getFormData(params.taskId));
    dispatch(getFormUploads(params.taskId));
  }, [dispatch, params]);

  useEffect(() => {
    if (task && task.processInstanceId && viewMode == true) {
      dispatch(
        getProcessInstances({
          processInstanceId: task.processInstanceId,
          taskId: params.taskId,
        })
      );
    }
  }, [dispatch, task]);

  // const disabledBeneficiaryTabs = isBeneficiary(user?.groups) && activeTaskName === "task.name.submit_application" ? true : false;
  const disabledBeneficiaryTabs =
    (isBeneficiary(user?.groups) &&
      activeTaskName === 'task.name.submit_application') ||
    (viewMode === true && activeTaskName === 'task.name.audit_application');

  return loadingPageVar ? (
    <main>
      <div
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
        }}
      >
        <Spin id="main-form-loading-spinner" size="large" />
      </div>
    </main>
  ) : (
    <div id="mainforms-page-1" className="investor-form-container">
      {!isNil(current) && (
        <div className="investor-steps-footer-container">
          {carrier?.rejectReasons?.isSubmitValid === false && (
            <ValidationBanner
              id="validation-banner"
              rejectReasons={carrier?.rejectReasons}
            />
          )}
          <TabsTimeline
            id="main-form-tabs-timeline"
            tabs={stepsBeneficiary(disabledBeneficiaryTabs)}
            current={current}
            setCurrent={setCurrent}
            customClass={`custom-tabs-timeline active-tab-${current + 1}`}
          />
          <FormFooter
            id="main-form-footer"
            tabs={stepsBeneficiary(disabledBeneficiaryTabs)}
            current={current}
            setCurrent={setCurrent}
            currentSubTab={currentSubTab}
          />
        </div>
      )}
    </div>
  );
};

export default MainForm;
